// Mock data for Baobab Institute of Tanzania (BIT)

// Prospectus PDF URL
export const prospectusUrl = "/Prospectus.pdf";

// External application form URL
export const applicationFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSf9yzsUZYHU-MPsJLDe24XGoX3Iaerbe2GRAaJ6E0dpKoZm5g/viewform?usp=header";

export const institutionInfo = {
  name: "Baobab Institute of Tanzania",
  shortName: "BIT",
  fullName: "BAOBAB INSTITUTE OF TANZANIA",
  location: "Mapinga, Bagamoyo District, Tanzania",
  address: "P.O. Box 35692, Bagamoyo, Tanzania",
  phone: "+255 759 549 641",
  phones: ["+255 759 549 641", "+255 750 559 641", "+255 766 559 641", "+255 696 929 641"],
  email: "info@bit.ac.tz",
  website: "bit-inst.ac",
  vocationalCenter: "www.bvc.ac",
  admissionsEmail: "admissions@bit.ac.tz",
  vision: "To establish a globally respected institution that leads in creating knowledge, shaping minds, and driving sustainable progress across multiple sectors of society. Baobab Institute of Tanzania aims to be a beacon of educational excellence that nurtures empowered individuals capable of transforming challenges into opportunities through leadership, collaboration, and a commitment to social equity, with a particular focus on securing the digital future.",
  mission: "To deliver forward-looking education that prepares students to thrive in an ever-evolving world. We are dedicated to creating a learner-centered environment where academic rigor, ethical values, creativity, and critical engagement are encouraged. Our mission includes advancing applied research, engaging with local and global communities, and building strong institutional partnerships that foster innovation, entrepreneurship, and social responsibility across all sectors of society.",
  coreValues: [
    { name: "Integrity", description: "Upholding honesty, transparency, and ethical conduct across all operations." },
    { name: "Excellence", description: "Striving for the highest standards in teaching, research, and community service." },
    { name: "Professionalism", description: "Promoting accountability, discipline, and commitment in all areas of work." },
    { name: "Innovation", description: "Fostering creativity, technological advancement, and forward-thinking solutions." },
    { name: "Teamwork", description: "Encouraging collaboration among staff, students, and partners to achieve shared goals." },
    { name: "Sustainability", description: "Advocating for practices that promote long-term societal and environmental well-being." },
    { name: "Respect and Equity", description: "Embracing diversity and ensuring inclusivity and fairness in all institutional processes." }
  ]
};

export const departments = [
  {
    id: "health-allied-sciences",
    name: "Department of Health and Allied Sciences",
    shortName: "Health & Allied Sciences",
    description: "Preparing healthcare professionals with cutting-edge medical training and ethical practice standards.",
    intakes: ["September"],
    image: "https://images.unsplash.com/photo-1645684996558-561e6c914e3e"
  },
  {
    id: "business-tourism-planning",
    name: "Department of Business, Tourism, and Planning",
    shortName: "Business, Tourism & Planning (BTP)",
    description: "Developing business leaders, hospitality professionals, and entrepreneurs with strong analytical and management skills for Tanzania's growing economy.",
    intakes: ["March", "September"],
    image: require('../assets/images/hotel-tourism-building.jpg')
  },
  {
    id: "science-allied-technologies",
    name: "Department of Science and Allied Technologies",
    shortName: "Science & Allied Technologies (SAT)",
    description: "Equipping students with advanced technical skills for the digital future.",
    intakes: ["March", "September"],
    image: "https://images.unsplash.com/photo-1719159381981-1327b22aff9b"
  }
];

export const programmes = [
  // Health & Allied Sciences (September only)
  {
    id: "pharmaceutical-sciences",
    name: "Pharmaceutical Sciences",
    departmentId: "health-allied-sciences",
    ntaLevels: [4, 5, 6],
    intakes: ["September"],
    duration: "3 Years",
    overview: "A comprehensive programme designed to train students in the science of medications, drug development, and pharmaceutical care. Students gain practical skills in drug dispensing, patient counseling, and pharmaceutical management.",
    entryRequirements: "Form IV Certificate with passes in Biology, Chemistry, and Mathematics/Physics. NTA Level 4 entry requires at least 4 passes including these subjects.",
    programmeStructure: "Year 1: Foundation courses in biology, chemistry, and introduction to pharmacy. Year 2: Advanced pharmacology, pharmaceutical chemistry, and clinical practice. Year 3: Specialization, industrial attachment, and research project.",
    careerPathways: ["Community Pharmacist", "Hospital Pharmacist", "Pharmaceutical Sales Representative", "Drug Inspector", "Research Assistant"]
  },
  {
    id: "clinical-medicine",
    name: "Clinical Medicine",
    departmentId: "health-allied-sciences",
    ntaLevels: [4, 5, 6],
    intakes: ["September"],
    duration: "3 Years",
    overview: "This programme prepares students to become Clinical Officers capable of diagnosing, treating, and managing common medical conditions. Emphasis is placed on practical clinical skills and patient-centered care.",
    entryRequirements: "Form IV Certificate with passes in Biology, Chemistry, and either Physics or Mathematics. Strong performance in science subjects is essential.",
    programmeStructure: "Year 1: Human anatomy, physiology, and basic medical sciences. Year 2: Clinical pathology, pharmacology, and diagnostic techniques. Year 3: Clinical rotations, emergency medicine, and supervised practice.",
    careerPathways: ["Clinical Officer", "Medical Assistant", "Health Center Manager", "Public Health Officer", "Medical Educator"]
  },
  {
    id: "physiotherapy",
    name: "Physiotherapy",
    departmentId: "health-allied-sciences",
    ntaLevels: [4, 5, 6],
    intakes: ["September"],
    duration: "3 Years",
    overview: "Train to become a skilled physiotherapist helping patients recover mobility and manage pain through therapeutic exercises and rehabilitation techniques.",
    entryRequirements: "Form IV Certificate with passes in Biology and either Chemistry or Physics. Good physical fitness and communication skills are advantageous.",
    programmeStructure: "Year 1: Anatomy, kinesiology, and introduction to physiotherapy. Year 2: Therapeutic techniques, rehabilitation methods, and patient assessment. Year 3: Clinical practice, specialized physiotherapy, and research.",
    careerPathways: ["Hospital Physiotherapist", "Sports Physiotherapist", "Rehabilitation Specialist", "Community Health Worker", "Private Practice Owner"]
  },
  // Business, Tourism & Planning Department (March & September)
  {
    id: "accounting-finance",
    name: "Accounting and Finance",
    departmentId: "business-tourism-planning",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Develop expertise in financial accounting, management accounting, and financial analysis. This programme prepares students for careers in corporate finance, banking, and public accounting.",
    entryRequirements: "Form IV Certificate with passes in Mathematics, English, and Book-keeping/Commerce. Basic computer literacy is recommended.",
    programmeStructure: "Year 1: Principles of accounting, business mathematics, and economics. Year 2: Financial accounting, cost accounting, and taxation. Year 3: Auditing, financial management, and professional practice.",
    careerPathways: ["Accountant", "Financial Analyst", "Bank Officer", "Tax Consultant", "Audit Assistant"]
  },
  {
    id: "accounting-taxation",
    name: "Accounting and Taxation",
    departmentId: "business-tourism-planning",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Specialize in tax law, tax planning, and compliance. This programme combines accounting fundamentals with in-depth knowledge of Tanzania's tax system.",
    entryRequirements: "Form IV Certificate with passes in Mathematics, English, and Book-keeping/Commerce. Interest in legal and regulatory frameworks is beneficial.",
    programmeStructure: "Year 1: Basic accounting, tax fundamentals, and business law. Year 2: Corporate taxation, VAT, and tax administration. Year 3: Tax planning, international taxation, and professional ethics.",
    careerPathways: ["Tax Accountant", "Tax Consultant", "Revenue Officer", "Compliance Officer", "Financial Advisor"]
  },
  {
    id: "digital-marketing",
    name: "Digital Marketing",
    departmentId: "business-tourism-planning",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Master the art and science of digital marketing including social media, SEO, content marketing, and data analytics. Prepare for the rapidly evolving digital economy.",
    entryRequirements: "Form IV Certificate with passes in English and Mathematics. Creativity, communication skills, and basic computer knowledge are essential.",
    programmeStructure: "Year 1: Marketing fundamentals, digital literacy, and communication. Year 2: Social media marketing, SEO/SEM, and content creation. Year 3: Marketing analytics, campaign management, and internship.",
    careerPathways: ["Digital Marketing Specialist", "Social Media Manager", "Content Creator", "SEO Specialist", "Marketing Analyst"]
  },
  {
    id: "hotel-tourism-management",
    name: "Hotel and Tourism Management",
    departmentId: "business-tourism-planning",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Comprehensive training in hospitality operations, tourism management, and customer service excellence. Prepare for Tanzania's booming tourism sector.",
    entryRequirements: "Form IV Certificate with passes in English, Geography, and Mathematics/Commerce. Good interpersonal skills and interest in hospitality are important.",
    programmeStructure: "Year 1: Introduction to hospitality, front office operations, and tourism geography. Year 2: Food & beverage management, housekeeping, and tour operations. Year 3: Hotel management, tourism marketing, and industrial attachment.",
    careerPathways: ["Hotel Manager", "Tour Operator", "Event Coordinator", "Restaurant Manager", "Travel Consultant"]
  },
  // Science & Allied Technologies Department (March & September)
  {
    id: "artificial-intelligence-ml",
    name: "Artificial Intelligence and Machine Learning",
    departmentId: "science-allied-technologies",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Cutting-edge programme covering AI fundamentals, machine learning algorithms, and practical applications. Prepare for the future of technology and automation.",
    entryRequirements: "Form IV Certificate with passes in Mathematics, Physics, and English. Strong analytical and problem-solving skills are essential.",
    programmeStructure: "Year 1: Programming fundamentals, mathematics for AI, and computer systems. Year 2: Machine learning, data structures, and neural networks. Year 3: Deep learning, AI applications, and capstone project.",
    careerPathways: ["AI Developer", "Machine Learning Engineer", "Data Scientist", "AI Research Assistant", "Automation Specialist"]
  },
  {
    id: "ict",
    name: "Information and Communication Technology (ICT)",
    departmentId: "science-allied-technologies",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Comprehensive ICT training covering networking, software development, database management, and IT support. Build skills for the digital economy.",
    entryRequirements: "Form IV Certificate with passes in Mathematics and English. Basic computer literacy and logical thinking ability are recommended.",
    programmeStructure: "Year 1: Computer fundamentals, programming basics, and networking introduction. Year 2: Database management, web development, and system administration. Year 3: Software engineering, project management, and industrial training.",
    careerPathways: ["Software Developer", "Network Administrator", "Database Administrator", "IT Support Specialist", "Web Developer"]
  },
  {
    id: "cybersecurity",
    name: "Cybersecurity and Digital Forensics",
    departmentId: "science-allied-technologies",
    ntaLevels: [4, 5, 6],
    intakes: ["March", "September"],
    duration: "3 Years",
    overview: "Learn to protect digital assets, secure information systems, and investigate cyber crimes. This programme covers ethical hacking, security protocols, cyber defense strategies, and digital forensics investigation techniques.",
    entryRequirements: "Form IV Certificate with passes in Mathematics and English. Interest in computer security and attention to detail are important.",
    programmeStructure: "Year 1: Computer fundamentals, networking basics, and security introduction. Year 2: Cryptography, ethical hacking, security tools, and digital evidence collection. Year 3: Penetration testing, incident response, forensic analysis, and security management.",
    careerPathways: ["Security Analyst", "Penetration Tester", "Digital Forensics Investigator", "Security Consultant", "IT Auditor", "Incident Response Specialist"]
  }
];

export const highlights = [
  {
    title: "Accredited Programmes",
    subtitle: "NTA Level 4-6",
    description: "All programmes are accredited by NACTE ensuring quality education and recognized qualifications."
  },
  {
    title: "Industry-Relevant Training",
    subtitle: "Practical Skills",
    description: "Curriculum designed with industry input to ensure graduates are job-ready from day one."
  },
  {
    title: "Student Support",
    subtitle: "Comprehensive Care",
    description: "Academic advising, counseling services, and career guidance throughout your journey."
  },
  {
    title: "Community Impact",
    subtitle: "Social Responsibility",
    description: "Engaging with local communities through outreach programs and sustainable initiatives."
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/82vhoj8w_DJI_0213.jpg",
  campus: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/82vhoj8w_DJI_0213.jpg",
  campusAerial: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/mczd9bnc_DJI_0228.jpg",
  campusOverview: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/zl3qorm5_DJI_0237.jpg",
  sportsFields: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/rfwj5tbn_DJI_0166.jpg",
  adminBlock: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/82vhoj8w_DJI_0213.jpg",
  awardCeremony: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/mn9yhe9h__ONC5166.jpg",
  sportsTeam: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/nvm1zhtr__ONC5351.jpg",
  students: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/mn9yhe9h__ONC5166.jpg",
  library: "https://images.unsplash.com/photo-1721702754494-fdd7189f946c",
  techLab: "https://images.unsplash.com/photo-1719159381981-1327b22aff9b",
  scienceLab: "https://images.pexels.com/photos/9574338/pexels-photo-9574338.jpeg",
  medical: "https://images.unsplash.com/photo-1645684996558-561e6c914e3e",
  medicalTraining: "https://images.unsplash.com/photo-1731357266501-fc8594f84707",
  business: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4"
};

// Campus Gallery Images
export const campusGallery = [
  {
    id: 1,
    title: "Administration Block",
    description: "The main administration building of BIT",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/82vhoj8w_DJI_0213.jpg"
  },
  {
    id: 2,
    title: "Campus Aerial View",
    description: "Bird's eye view of the BIT campus",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/mczd9bnc_DJI_0228.jpg"
  },
  {
    id: 3,
    title: "Campus Overview",
    description: "Multiple buildings and facilities at BIT",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/zl3qorm5_DJI_0237.jpg"
  },
  {
    id: 4,
    title: "Sports Facilities",
    description: "Football fields and sports grounds",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/rfwj5tbn_DJI_0166.jpg"
  },
  {
    id: 5,
    title: "Award Ceremony",
    description: "Student achievements and recognition",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/mn9yhe9h__ONC5166.jpg"
  },
  {
    id: 6,
    title: "Sports Team",
    description: "BIT sports team with trophy",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania-portal/artifacts/nvm1zhtr__ONC5351.jpg"
  }
];

export const footballEvent = {
  id: "bit-football-match-campus-sports-event",
  title: "BIT Football Match – Campus Sports Event",
  category: "Sport | Student Life",
  location: "Baobab Institute of Tanzania (BIT) Campus, Mapinga, Bagamoyo, Tanzania",
  date: "August 2025",
  description: "Baobab Institute of Tanzania (BIT) hosted an exciting football match showcasing student athleticism, teamwork, and campus spirit. The event brought together teams from BIT and neighbouring institutions, promoting sportsmanship, healthy competition, and community engagement among students and staff.",
  impactLine: "This event celebrates BIT's commitment to holistic student development, teamwork, health, and community involvement.",
  images: [
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/4umf1fsv__ONC3742.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/oba38gy3__ONC3764.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/6lfdhqz5__ONC3766.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/z1xegzvi__ONC3796.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/0o9sd4mo__ONC3813.jpg"
  ]
};

export const fashionShowEvent = {
  id: "bit-fashion-show-and-modeling-event",
  title: "BIT Fashion Show and Modeling Event",
  category: "Student Life | Creative & Cultural Activities",
  location: "BIT Campus, Mapinga, Bagamoyo, Tanzania",
  date: "August 2025",
  description: "Baobab Institute of Tanzania (BIT) successfully hosted a Fashion Show and Modeling Event aimed at promoting student creativity, confidence, talent development, and industry exposure. The event provided a professional platform for young models and designers to showcase their skills while strengthening student engagement and institutional branding.",
  impactLine: "This event supports BIT's commitment to holistic education, creativity, and youth empowerment alongside academic excellence.",
  images: [
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/q94mkjm8__ONC4529.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/8cw7petp__ONC4538.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/2a8zdon8__ONC4564.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/v18vj2u8__ONC4571.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/f1sp02wn__ONC4586.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/x8g70bpq__ONC4616.jpg",
    "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/okrsaezt__ONC4647.jpg"
  ]
};

export const newsEvents = [
  {
    id: "bit-football-match-campus-sports-event",
    title: "BIT Football Match – Campus Sports Event",
    date: "August 2025",
    excerpt: "Baobab Institute of Tanzania (BIT) hosted an exciting football match showcasing student athleticism, teamwork, and campus spirit.",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/4umf1fsv__ONC3742.jpg",
    category: "Sport"
  },
  {
    id: "bit-fashion-show-and-modeling-event",
    title: "BIT Fashion Show and Modeling Event",
    date: "August 2025",
    excerpt: "Baobab Institute of Tanzania (BIT) successfully hosted a Fashion Show and Modeling Event aimed at promoting student creativity, confidence, talent development, and industry exposure.",
    image: "https://customer-assets.emergentagent.com/job_bit-tanzania/artifacts/q94mkjm8__ONC4529.jpg",
    category: "Student Life"
  },
  {
    id: 3,
    title: "September 2025 Intake Now Open",
    date: "August 15, 2025",
    excerpt: "Applications are now being accepted for the September 2025 intake across all departments. Early application is encouraged.",
    image: images.campus
  },
  {
    id: 4,
    title: "New AI & Machine Learning Lab Inaugurated",
    date: "July 28, 2025",
    excerpt: "BIT has unveiled a state-of-the-art AI laboratory equipped with modern computing resources for students.",
    image: images.techLab
  },
  {
    id: 5,
    title: "Partnership with Leading Healthcare Facilities",
    date: "July 10, 2025",
    excerpt: "BIT has signed MoUs with major hospitals in Dar es Salaam for student clinical attachments.",
    image: images.medical
  }
];

export const partners = [
  { name: "HESLB", url: "https://www.heslb.go.tz" },
  { name: "NACTVET", url: "https://www.nactvet.go.tz" },
  { name: "NECTA", url: "https://www.necta.go.tz" },
  { name: "IUCEA", url: "https://www.iucea.org" },
  { name: "AAU", url: "https://www.aau.org" },
  { name: "AfriQAN", url: "https://www.afriqan.aau.org" },
  { name: "UNESCO", url: "https://www.unesco.org" },
  { name: "Ministry of Health", url: "https://www.moh.go.tz" }
];

export const admissionSteps = [
  { step: 1, title: "Review Requirements", description: "Check programme entry requirements and ensure you meet the criteria." },
  { step: 2, title: "Prepare Documents", description: "Gather all required documents including certificates and identification." },
  { step: 3, title: "Submit Application", description: "Complete the online application form with accurate information." },
  { step: 4, title: "Pay Application Fee", description: "Submit the non-refundable application processing fee." },
  { step: 5, title: "Await Decision", description: "Applications are reviewed and decisions communicated within 2-4 weeks." },
  { step: 6, title: "Enrollment", description: "Accepted students complete registration and begin their studies." }
];

export const requiredDocuments = [
  "Certified copy of Form IV Certificate (CSEE)",
  "Certified copy of Form VI Certificate (if applicable)",
  "Birth Certificate",
  "National ID or Passport",
  "Two passport-size photographs",
  "Medical fitness certificate",
  "Letter of recommendation (optional)"
];

export const regions = [
  "Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera", "Katavi", 
  "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara", "Mbeya", "Morogoro", 
  "Mtwara", "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani", 
  "Rukwa", "Ruvuma", "Shinyanga", "Simiyu", "Singida", "Songwe", "Tabora", 
  "Tanga", "Unguja North", "Unguja South", "Zanzibar"
];

// Professional Short Courses
export const shortCourses = {
  clinicalMedicine: {
    category: "Clinical Medicine",
    icon: "Stethoscope",
    description: "Enhance your clinical skills with specialized emergency and critical care training programs.",
    courses: [
      { id: 1, title: "Disaster Medicine", duration: "2 Weeks", fee: 350000 },
      { id: 2, title: "Point-of-Care Emergency Ultrasound", duration: "1 Month", fee: 450000 },
      { id: 3, title: "Basic Emergency Care", duration: "1 Month", fee: 400000 },
      { id: 4, title: "Emergency & Critical Care Support (Basic/Advanced)", duration: "2 Months", fee: 600000 },
      { id: 5, title: "Advanced Critical Care Training (AFRI-Crit)", duration: "1 Month", fee: 500000 }
    ]
  },
  physiotherapy: {
    category: "Physiotherapy",
    icon: "Activity",
    description: "Advance your physiotherapy practice with specialized rehabilitation and treatment techniques.",
    courses: [
      { id: 1, title: "Physiopedia Plus Micro-Courses (e.g., heel pain, tendon rehab)", duration: "2 Weeks", fee: 300000 },
      { id: 2, title: "Physio-Network Online Masterclasses", duration: "1 Month", fee: 400000 },
      { id: 3, title: "PhysicalTherapy.com CE Courses", duration: "1 Month", fee: 450000 },
      { id: 4, title: "Physio Academy Specialized Modules", duration: "1 Month", fee: 450000 },
      { id: 5, title: "SmartPT Academy in Specialized Areas", duration: "1 Month", fee: 500000 }
    ]
  },
  pharmaceuticalSciences: {
    category: "Pharmaceutical Sciences",
    icon: "Pill",
    description: "Develop expertise in clinical pharmacy, pharmacovigilance, and pharmaceutical research.",
    courses: [
      { id: 1, title: "Clinical Pharmacy, Pharmacovigilance & Applied Pharmacokinetics", duration: "1 Month", fee: 500000 },
      { id: 2, title: "Basic Technician Certificate in Pharmaceutical Sciences (modular)", duration: "3-6 Months", fee: 700000 },
      { id: 3, title: "Certificate in Pharmaceutical Science (short-track)", duration: "6 Months", fee: 750000 },
      { id: 4, title: "Diploma in Pharmaceutical Sciences (select modules)", duration: "6 Months", fee: 800000 },
      { id: 5, title: "Professional Diploma in Clinical Research & Pharmacovigilance", duration: "3 Months", fee: 800000 }
    ]
  },
  informationTechnology: {
    category: "Information Technology",
    icon: "Monitor",
    description: "Master cutting-edge technology skills from cybersecurity to AI and machine learning.",
    courses: [
      { id: 1, title: "Advanced Computer Package", duration: "2 Months", fee: 300000 },
      { id: 2, title: "Advanced Excel Pro and Automation", duration: "1 Month", fee: 450000 },
      { id: 3, title: "Cybersecurity and Digital Forensics", duration: "3 Months", fee: 600000 },
      { id: 4, title: "Digital Marketing", duration: "2 Months", fee: 450000 },
      { id: 5, title: "Advanced Machine Learning Models and Optimization Techniques", duration: "3 Months", fee: 750000 },
      { id: 6, title: "AI for Business Intelligence and Decision Support", duration: "3 Months", fee: 800000 },
      { id: 7, title: "Graphics Design", duration: "2 Months", fee: 300000 },
      { id: 8, title: "Big Data Analytics and Scalable AI Systems", duration: "3 Months", fee: 800000 },
      { id: 9, title: "AI Project Management and Agile Development Practices", duration: "2 Months", fee: 550000 }
    ]
  }
};


// BIT Startups & Innovation Ecosystem
export const startups = [
  {
    id: "bitech-ai",
    name: "BITECH AI and Cyber Solution",
    shortName: "BITECH",
    tagline: "Securing Tomorrow's Digital Frontier",
    logo: require('../assets/logos/bitech-logo.png'),
    heroImage: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200",
    description: "BITECH AI and Cyber Solution is a forward-thinking technology company established to drive digital transformation, intelligent automation, and cyber resilience across Africa and beyond. Founded under the innovation ecosystem of Baobab Institute of Tanzania (BIT), the company represents a new generation of African technological excellence focused on Artificial Intelligence, Cyber Security, Digital Forensics, and advanced digital solutions.",
    fullDescription: "The company was created with a mission to empower institutions, businesses, and individuals through secure, intelligent, and future-oriented technology systems capable of solving real-world challenges in the modern digital era. BITECH AI and Cyber Solution combines innovation, research, security intelligence, and advanced computing to deliver reliable, scalable, and high-performance technological solutions.",
    founded: "2024",
    location: "Bagamoyo, Tanzania",
    email: "info@bitech.co.tz",
    phone: "+255 759 549 641",
    website: "www.bitech.co.tz",
    status: "active",
    vision: "To become Africa's leading provider of AI-powered cybersecurity solutions and intelligent digital systems, creating a safer and smarter digital ecosystem for businesses, institutions, and individuals across the continent and beyond.",
    mission: "To empower organizations through secure, intelligent, and future-oriented technology solutions that drive digital transformation, protect digital assets, and solve real-world challenges in the modern digital era.",
    services: [
      { name: "Artificial Intelligence Solutions", description: "Custom AI models, machine learning systems, natural language processing, and intelligent automation for business optimization and decision-making.", icon: "Brain" },
      { name: "Cyber Security Protection", description: "Comprehensive security assessments, threat detection, security infrastructure implementation, and 24/7 monitoring services.", icon: "Shield" },
      { name: "Digital Forensics & Investigation", description: "Expert investigation of cyber incidents, data recovery, evidence analysis, and forensic reporting for legal proceedings.", icon: "Search" },
      { name: "Ethical Hacking & Penetration Testing", description: "Authorized security testing to identify vulnerabilities before malicious actors can exploit them.", icon: "Target" },
      { name: "Software & Web Development", description: "Custom software solutions, web applications, mobile apps, and enterprise systems tailored to your business needs.", icon: "Code" },
      { name: "AI Automation Systems", description: "Intelligent process automation, chatbots, workflow optimization, and AI-driven business process management.", icon: "Zap" },
      { name: "Cloud & Network Security", description: "Secure cloud migration, network architecture design, and comprehensive infrastructure protection.", icon: "Cloud" },
      { name: "Cyber Awareness & Training", description: "Employee training programs, security awareness workshops, and certification courses on cybersecurity best practices.", icon: "GraduationCap" },
      { name: "IT Consultancy & Infrastructure", description: "Strategic IT planning, infrastructure optimization, and technology roadmap development.", icon: "Server" },
      { name: "Data Analytics & Intelligent Systems", description: "Business intelligence, predictive analytics, and data-driven insights for strategic decision making.", icon: "BarChart" }
    ],
    highlights: [
      { title: "AI-Powered Threat Detection Platform", status: "Coming Soon", description: "Next-generation threat detection using advanced machine learning algorithms and behavioral analysis." },
      { title: "Cyber Range Training Platform", status: "In Development", description: "Immersive cybersecurity training environment for hands-on learning and skill development." },
      { title: "Digital Forensics Laboratory", status: "Coming Soon", description: "State-of-the-art forensics laboratory equipped with advanced tools for evidence analysis." },
      { title: "African Cyber Security Research Center", status: "Planned", description: "Research hub focused on emerging cyber threats and security solutions for the African context." }
    ],
    colors: {
      primary: "#0066cc",
      secondary: "#00a3e0",
      accent: "#00d4ff",
      gradient: "linear-gradient(135deg, #001a33 0%, #003366 50%, #0066cc 100%)"
    }
  },
  {
    id: "afrovanta",
    name: "AfroVanta Digital Hub",
    shortName: "AfroVanta",
    tagline: "Innovate • Create • Elevate",
    logo: require('../assets/logos/afrovanta-logo.png'),
    heroImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200",
    description: "AfroVanta Digital Hub is a premium creative and digital innovation company dedicated to transforming brands, businesses, and organizations through modern digital marketing, strategic branding, and creative media excellence. Emerging from the innovative environment of Baobab Institute of Tanzania (BIT), AfroVanta Digital Hub was established to redefine African digital creativity through world-class media solutions and futuristic marketing strategies.",
    fullDescription: "The company operates at the intersection of creativity, technology, business intelligence, and digital communication, offering powerful solutions that help businesses grow, connect, and compete in the evolving global digital economy. AfroVanta Digital Hub combines modern design aesthetics, strategic storytelling, advanced digital marketing, and innovative brand positioning to create impactful and memorable brand experiences.",
    founded: "2024",
    location: "Bagamoyo, Tanzania",
    email: "hello@afrovanta.co.tz",
    phone: "+255 759 549 641",
    website: "www.afrovanta.co.tz",
    status: "active",
    vision: "To be Africa's leading digital innovation and creative agency, transforming brands and empowering businesses to achieve global competitiveness through cutting-edge digital solutions and creative excellence.",
    mission: "To deliver world-class digital marketing, branding, and creative media solutions that help African businesses and organizations grow, connect with their audiences, and thrive in the global digital economy.",
    services: [
      { name: "Digital Marketing & Advertising", description: "Strategic digital campaigns, SEO, SEM, PPC advertising, and performance marketing to maximize your online reach and ROI.", icon: "TrendingUp" },
      { name: "Social Media Management", description: "End-to-end social media strategy, content planning, community management, and engagement optimization across all platforms.", icon: "Share2" },
      { name: "Branding & Corporate Identity", description: "Complete brand identity development, logo design, brand guidelines, and strategic brand positioning.", icon: "Palette" },
      { name: "Graphic Design & Creative Media", description: "Stunning visual designs for print, digital, social media, and marketing collateral that capture attention.", icon: "PenTool" },
      { name: "Content Creation & Visual Storytelling", description: "Engaging written, visual, and multimedia content that tells your brand story and resonates with your audience.", icon: "FileText" },
      { name: "Website Design & Digital Presence", description: "Modern, responsive website design and development that establishes your digital presence and drives conversions.", icon: "Globe" },
      { name: "Video Production & Media Campaigns", description: "Professional video production, commercials, documentaries, and multimedia campaigns that engage and inspire.", icon: "Video" },
      { name: "Business Promotion & Brand Visibility", description: "Integrated promotional campaigns, influencer partnerships, and strategic visibility initiatives.", icon: "Megaphone" },
      { name: "Digital Strategy & Online Growth", description: "Comprehensive digital transformation strategies and growth roadmaps for sustainable business success.", icon: "LineChart" },
      { name: "Creative Consultancy & Media Innovation", description: "Expert creative consulting, trend analysis, and innovative media solutions for forward-thinking brands.", icon: "Lightbulb" }
    ],
    highlights: [
      { title: "AfroVanta Creative Studio", status: "Coming Soon", description: "Full-service creative production facility for content creators, influencers, and brands." },
      { title: "Digital Marketing Academy", status: "In Development", description: "Comprehensive training programs for aspiring digital marketers and creative professionals." },
      { title: "Brand Accelerator Program", status: "Coming Soon", description: "Intensive branding bootcamp designed to fast-track startups and SMEs to market success." },
      { title: "African Creative Network", status: "Planned", description: "Platform connecting African creatives, designers, and marketers for collaboration and growth." }
    ],
    colors: {
      primary: "#0066cc",
      secondary: "#ff9500",
      accent: "#ffb347",
      gradient: "linear-gradient(135deg, #001a33 0%, #0066cc 50%, #ff9500 100%)"
    }
  }
];
